$( document ).ready(function() {

  $('.calc__btn').on('click', function() {

    // Setup Currency Formatter
    var formatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 0,
    });


    // Base Pricing
    var generator_price = 20000,
        maintenance_price = 500,
        applicator_price = 50,
        lease_price = 100.74,
        clientsPerWeek = $('.calc__input-clients').val().replace(/[^0-9\.]/g, ''),
        clinicCharge = $('.calc__input-charge').val().replace(/[^0-9\.]/g, ''),
        leasing = false;

    if( $('.calc__input-option').val() == 'lease' ) {
      leasing = true;
      generator_price = 0;
      maintenance_price = 0;
    }

    // Revenue Setup
    var revenue = clinicCharge * clientsPerWeek * 260;
    
    
    // Expenditure Setup
    var expend = generator_price,
        expend = expend + ( (applicator_price * clientsPerWeek ) * 4 ),
        expend = expend + ( (applicator_price * clientsPerWeek * 2) * 4 ),
        expend = expend + ( (applicator_price * clientsPerWeek * 3) * 252 ),
        expend = expend + ( (maintenance_price * 1.2) * 5 );

    if( leasing ) {
      expend = expend + ( lease_price * 260 );
    }
    
    
    // Profit Setup
    var profit = revenue - expend,
        formattedProfit = Math.round(profit),
        formattedProfit = formatter.format(formattedProfit);

    if ( revenue < expend ) {

      $('.calc__notprofitable').show();
      $('.calresu').hide();

    } else {

      $('.calc__notprofitable').hide();
      $('.calresu__output-total').text(formattedProfit);

      // Total Customers Setup
      var firstRound = clientsPerWeek * 4,
          secondRound = ( clientsPerWeek * 2 ) * 4,
          thirdRound = ( clientsPerWeek * 3 ) * 44,
          fourthRound = ( clientsPerWeek * 3 ) * 52,
          totalCust = firstRound + secondRound + thirdRound;

      // Hourly Pricing Setup
      var firstYear = totalCust * 15 / 60 / 8,
          otherYears = fourthRound * 15 / 60 / 8,
          hourlyPrice = (profit/5) / (( ((otherYears * 4) + firstYear)/5 ) * 8 ),
          hourlyPrice = Math.round(hourlyPrice),
          hourlyPrice = formatter.format(hourlyPrice);

      $('.calresu__output-hourly').text(hourlyPrice);


      // Weeks Till Profit
      var weekNo = 1,
          recurringExpenditure = 0,
          recurringProfit = 0;

      while( weekNo <= 260 ) {

        if( weekNo == 1 ) {
          recurringExpenditure += generator_price;
          recurringExpenditure += (maintenance_price * 1.2);
        }

        if( weekNo >= 1 && weekNo <= 4 ) {
          recurringExpenditure += (applicator_price * clientsPerWeek );
        }

        if( weekNo >= 5 && weekNo <= 8 ) {
          recurringExpenditure += (applicator_price * (clientsPerWeek * 2) );
        }

        if( weekNo >= 9 ) {
          recurringExpenditure += (applicator_price * (clientsPerWeek * 3) );
        }

        if( weekNo == 53 || weekNo == 105 || weekNo == 157 || weekNo == 209 ) {
          recurringExpenditure += (maintenance_price * 1.2);
        }

        if( leasing ) {
          recurringExpenditure += lease_price;
        }


        recurringProfit += clinicCharge * clientsPerWeek;

        if( (recurringProfit - recurringExpenditure) > 0 ) {
          
          if( weekNo == 1 ) {
            var weeks = '  week';
          } else {
            var weeks = '  weeks';
          }
          
          $('.calresu__output-weeks').text(weekNo + weeks);
          break;
        }

        weekNo = weekNo + 1;

      }

      $('.calresu').show();
      
      $('html, body').animate({
        scrollTop: $(".calresu").offset().top
      }, 1000);

    }

  });

});